<template>
    <div class="vx-col w-full p-5 edu-block">
        <div class="dependent-block_wrap">
            <div v-if="ish1bCase" class="dependent-block dependent-block_v2" @click="goToDetailsPage(petition['_id'] )">
                <div  class="dependent_details case_details">
                    <ul>
                        <li v-if="checkProperty(petition,'caseNo')"> Case No <span class="cursor-pointer">{{checkProperty(petition,'caseNo')}}</span></li>
                    </ul>
                    <ul>
                        <li v-if="checkProperty(petition,'typeName')"> Case Type <span>{{checkProperty(petition,'typeName')}}</span></li>
                        <li v-if="checkProperty(petition,'subTypeName')">Case Subtype <span>{{checkProperty(petition,'subTypeName')}}</span></li>
                        <li v-if="checkProperty(petition,'createdByDetails')">Created By <span>{{petition['createdByDetails']["name"]}}</span></li>
                        <li v-if="checkProperty(petition,'createdOn')">Created On<span>{{checkProperty(petition ,'createdOn') | formatDateTime}}</span></li>
                    </ul>
                                
                </div>
               
            </div>


            <div class="dependent-block mb-3 dependent-block_v2" v-else v-for="(item,index) in petition" >
                <div class="dependent_details case_details" @click="goToDetailsPage(item['_id'] )" >
                    <div>
                    <ul>
                        <li v-if="checkProperty(item,'caseNo')"> Case No <span class="cursor-pointer">{{checkProperty(item,'caseNo')}}</span></li>
                    </ul>
                    <ul>
                        <li v-if="checkProperty(item,'typeName')"> Case Type <span>{{checkProperty(item,'typeName')}}</span></li>
                        <li v-if="checkProperty(item,'subTypeName')">Case Subtype <span>{{checkProperty(item,'subTypeName')}}</span></li>
                        <li v-if="checkProperty(item,'createdByDetails')">Created By <span>{{item['createdByDetails']["name"]}}</span></li>
                        <li v-if="checkProperty(item,'createdOn')">Created On<span>{{checkProperty(item ,'createdOn') | formatDateTime}}</span></li>
                    </ul>
                </div>         
                </div>
            </div>

            
        </div>
    </div>
</template>
<script>

    export default {
        data: () => ({}),
        computed: {

        },
        props: {
            ish1bCase:{
            type: Boolean,
            default: false,
        },
        petition: {
            type: Object,
            default: null
        },
        renderFrom:{
            type: String,
            default: ''
        }
        },
        components: {
           
        },
        methods: {
           goToDetailsPage(routedId) {
                
                if (routedId) {
                    this.$emit('activeTab',"Case Details")
                    this.$router.push({ path: `/petition-details/${routedId}` }).catch(err => { })
                }
           },
        },
        mounted() {
            //console.log("@@@@@@@@",this.ish1bCase)
        }
    };
    </script>
    